import type { ReactNode } from "react"
import cc from "classnames"

interface ContainerProps {
  children: ReactNode
  full_width?: boolean
  almost_full_width?: boolean
  class_name?: string
  mobile_full_screen?: boolean
}

const Container = (props: ContainerProps): JSX.Element => {
  const defaultClass = props.mobile_full_screen ? "md:container" : "container"
  const almostFullWidth = props.almost_full_width ? "container--limit-fullwidth" : ""
  const className = props.class_name ? props.class_name : ""

  if (props.full_width) {
    return <div className={`${className}`}>{props.children}</div>
  }

  return <div className={cc(["@container", defaultClass, className, almostFullWidth])}>{props.children}</div>
}

export default Container
